import { render, staticRenderFns } from "./SectionBackgroundImage.vue?vue&type=template&id=2d855a63&"
import script from "./SectionBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./SectionBackgroundImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports